export default __webpack_public_path__ + "e0cb1e0f57199ee2ab37d01405accae4.svg";